import React from 'react';
import SMConst from 'lib/SMConst';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMOReservationActionView extends React.Component {
  
  confirm(e) {
    this.trackPageEvent('od confirm reservation');
    if(this.props.delegate && typeof this.props.delegate.confirmActionDidSelect === 'function'){
      this.props.delegate.confirmActionDidSelect(e);
    }
  }
  
  reject(e) {
    this.trackPageEvent('od reject reservation');
    if(this.props.delegate && typeof this.props.delegate.rejectActionDidSelect === 'function'){
      this.props.delegate.rejectActionDidSelect(e);
    }
  }
  
  cancel(e) {
    this.trackPageEvent('od cancel reservation');
    if(this.props.delegate && typeof this.props.delegate.cancelActionDidSelect === 'function'){
      this.props.delegate.cancelActionDidSelect(e);
    }
  }
  
  refund(e) {
    this.trackPageEvent('od refund reservation');
    if(this.props.delegate && typeof this.props.delegate.refundActionDidSelect === 'function'){
      this.props.delegate.refundActionDidSelect(e);
    }
  }
  
  showReviewForm(e) {
    this.trackPageEvent('od show review_form');
    if(this.props.delegate && typeof this.props.delegate.showReviewFormActionDidSelect === 'function'){
      this.props.delegate.showReviewFormActionDidSelect(e);
    }
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  render() {
    const reservation = this.props.reservation;
    let rows = [];
    
    if (reservation.method == SMConst.ReservationMethod.Inquiry) {
      rows.push(<a onClick={this.trackPageEvent.bind(this,'od change inquiry_to_reservation_2')} key="change" href={Routes.edit_owner_dashboard_reservation_path(reservation.owner.username, reservation.uid)} className="button-green pt13 pb13 w180">{I18n.t("dashboard.label_000147")}</a>);
    } else {
      switch (reservation.status) {
        case SMConst.ReservationStatus.Sent:
        case SMConst.ReservationStatus.EntrustedOwner:
        case SMConst.ReservationStatus.Requested:
          rows.push(<a key="reject" onClick={this.reject.bind(this)} href="#" className="button-gray pt13 pb13 w180">{I18n.t("dashboard.label_000110")}</a>);
          rows.push(<a key="confirm" onClick={this.confirm.bind(this)} href="#" className="button-green pt13 pb13 w180 ml5">{I18n.t("dashboard.label_000109")}</a>);
          break;
        case SMConst.ReservationStatus.CancelSent:
          if (reservation.billing.paid_at || reservation.billing.payment_method === SMConst.PaymentMethod.Postpay) {
            rows.push(<a key="refund" onClick={this.refund.bind(this)} href="#" className="button-green pt13 pb13 w180">{I18n.t("dashboard.label_000140")}</a>);
          }
          break;
        default:
          if (reservation.can_be_cancelled) {
            rows.push(<a key="cancel" onClick={this.cancel.bind(this)} href="#" className="button-gray pt13 pb13 w180">{I18n.t("dashboard.label_000077")}</a>);
          }
          if (reservation.can_be_reviewed) {
            rows.push(<a key="review" onClick={this.showReviewForm.bind(this)} href="#" className="button-green pt13 pb13 pl5 w180 ml5">{I18n.t("dashboard.label_000139")}</a>);
          }
      }
    }
    return(
      <p className="reserve-status-action-button reserve-status-buttonarea">
        {rows}
      </p>
    );
  }
}

export default SMOReservationActionView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationActionView.jsx